<template>
	<div id="app">
		<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.15.4/css/all.css"/>
		<router-view />
	</div>
</template>

<template>
	<div :style="cssProps" id="smd" :class="[(collapsed || 
			this.$route.path.startsWith('/form/')) ? 'collapsed' : '']">
		
		<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.15.4/css/all.css"/>

		<saas-navbar />

		<div class="smd" >
			<notifications position="top center" group="info" />
			<router-view
				@loginSuccess="() => userLoggedIn()"
				@styleUpdated="() => handleUserStyle()" />
		</div>
	</div>
</template>

<script>
	import database from "./services/database.js";
	import users from "./services/users.js";

	import logo from "./components/logo.vue";
	import store from "./store";
	import utils from "./services/utils.js";

	import navbar from "./components/navbar.vue";

	export default {
		props: ["visible"],
		data: function () {
			return {
				menu_color: {},
				collapsed: false,
				menu: [],
				theme: null,
				tablestyle: null,
				user: {},
			};
		},
		computed: {
			cssProps() {
				//console.log("Computing cssProps");

				let finalProps = {
					"--menu_background_color": this.menu_color.background_color,
					"--menu_sub_background_color":
						this.menu_color.sub_background_color,
					"--menu_select_background_color":
						this.menu_color.select_background_color,
					"--menu_icon_background_color":
						this.menu_color.icon_background_color,
					"--menu_select_color": this.menu_color.select_color,
					"--menu_sub_select_color": this.menu_color.sub_select_color,
				};

				if (this.theme !== null) {
					//console.log("Setting theme background color: ", this.theme);
					finalProps = {
						...finalProps,
						...{
							"--theme-font":
								this.theme.text_font + ", sans serif",
							"--theme-background-color":
								this.theme.background_color,
							"--theme-text-color": this.theme.text_color,
							"--theme-text-color-light":
								this.theme.text_color_light,
						},
					};
				}

				if (this.tablestyle !== null) {
					finalProps = {
						...finalProps,
						...{
							"--tables-header-background":
								this.tablestyle.header_background_color,
							"--tables-header-text-color":
								this.tablestyle.header_text_color,
							"--tables-cell-background":
								this.tablestyle.cell_background_color,
							"--tables-cell-text-color":
								this.tablestyle.cell_text_color,
							"--tables-col-border-thickness":
								this.tablestyle.col_border_thickness,
							"--tables-row-border-thickness":
								this.tablestyle.row_border_thickness,
							"--tables-border-color":
								this.tablestyle.border_color,
						},
					};
				}
				return finalProps;
			},
			themeFontFamily() {
				return this.theme === null
					? ""
					: `font-${this.theme.text_font}`;
			},
			themeBackgroundColor() {
				// return ("bg-[#ffadad]")
				return this.theme === null
					? ""
					: `bg-[${this.theme.background_color}]`;
			},
		},
		components: {
			logo,
			"saas-navbar": navbar,
		},
		created: async function () {
			var self = this;

			console.log("store.state.lang")
			console.log(store.state.lang)
			this.$root.$i18n.locale = store.state.lang;

			document.title = process.env.VUE_APP_NAME || this.$t('smartmydata');

			var link = document.querySelector("link[rel~='icon']");
			link.href = process.env.VUE_APP_FAVICON || "/favicon.ico";

			try {
				var response = await users.getSelf(true);
				if (response) {
					//console.log("In app, found user setting style");
					this.user = response.user;
					this.client = response.client;
					if (this.client.details && this.client.details.style)
						store.commit("setStyle", this.client.details.style);
				}
			} catch (err) {
				console.warn(err);
			}

			await this.menu_style(store.state.style);

			await this.buildMenu();

			this.collapsed = store.state.collapsed;

		},
		methods: {
			userLoggedIn() {
				//console.log("Logged in");
				this.handleUserStyle();
			},
			async handleUserStyle() {
				try {
					var response = await users.getSelf(true);

					// * necessaire de instantanément set le style ??
					if (response) {
						this.user = response.user;
						this.client = response.client;
						if (this.client.details && this.client.details.style)
							store.commit("setStyle", this.client.details.style);
					}
				} catch (err) {
					console.warn(err);
				}

				//console.log("State style after user login ", store.state.style);

				await this.menu_style(store.state.style);
			},
			async menu_style(data) {
				if (data && data.menu && Object.keys(data.menu).length !== 0) {
					this.menu_color = data.menu;
					//console.log("Setting menu style");
				} else {
					//console.log("Style vide !");
					this.menu_color = {
						background_color: "#2a2a2e",
						sub_background_color: "#36363b",
						select_background_color: "#4285f4",
						icon_background_color: "#1e1e21",
						select_color: "rgba(30,30,33,.5)",
						sub_select_color: "rgba(30,30,33,.5)",
					};
				}

				if (data && data.theme) {
					this.theme = data.theme;
				} else {
					//console.log("Tombé dans un theme vide !");
					this.theme = {}; // * rare de tomber ici
				}

				if (data && data.tablestyle) this.tablestyle = data.tablestyle;
				else this.tablestyle = null;
			},
			async buildMenu() {
				var self = this;

				try {
					var user = {};
					var response = await users.getSelf(true).catch(err =>
					{
						self.$router.push({ name: "login" });
						return null;
					});
					if (response) {
						user = response.user;
						this.client = response.client;

						await users.reniew()
					}
					else
					{
						console.log("no user")
						return;
					}

					if (
						!user &&
						(!this.from ||
							(this.from && !this.from.name.startsWith("login")))
					)
						this.$router.push({ name: "login" });

					this.$store.commit("setUser", user);

					// console.log(user)

					this.menu = [
						{
							header: true,
							component: logo,
						},
					];

					// traitements

					var items = [];
				}
				catch (err)
				{
					
				}

			},
            isAdmin: function() {
                return store.getters.isUserAdmin;
            },
			onCollapse(collapsed) {
				this.collapsed = collapsed;
			},
		},
		watch: {
			collapsed() {
				this.$store.commit("setCollapsed", this.collapsed);
			},
			async $route(to, from) {
				this.from = from;
				if (from.name && from.name.startsWith("login")) {
					await this.buildMenu();

					//console.log("Reloading window");
					//window.location.reload();
				}

				// console.log("Changement de route :", to);
				// todo check si le jwt est toujours valide
				let jwtToken = this.$store.state.jwt;
				// console.log("Récupération du jwt: ", jwtToken);
				let isTokenValid = utils.isTokenValid(jwtToken);
				//console.log("Le token est valide? ", isTokenValid);

				if (isTokenValid === false) {
					this.$notify({
						group: "info",
						title: "Attention:",
						text: this.$t('connect.expited_ssession'),
						type: "warn",
						duration: -1, // * dure infiniment
						closeOnClick: true,
					});
				}
				// si non, on notifie l'utilisateur
			},
		},
	};
</script>

<style>
	textarea {
		resize: both !important;
	}
	html {
		margin: 0;
		padding: 0;
		height: 100%;
	}
	body {
		font-family: "Source Sans Pro", sans-serif;
		background-color: #f2f4f7 !important;
		min-height: 100%;
	}

	#smd {
		padding-left: 0px;
		font-family: var(--theme-font) !important;
		background-color: var(--theme-background-color) !important;
		color: var(--theme-text-color) !important;

		min-height: 100vh;
	}
	#smd.collapsed {
		padding-left: 0px;
	}
	.smd {
		padding: 0px;
	}
	.badge-danger {
		background-color: #ff2a2a;
		color: #fff;
	}

	.marge {
		margin-left: 2em;
	}

	/* * si le CSS se calcule avant le JS on a peut-être un probleme */
	.v-sidebar-menu {
		color: #fff;
		background-color: var(--menu_background_color) !important;
	}

	.v-sidebar-menu .vsm-dropdown > .vsm-list {
		color: #fff;
		background-color: var(--menu_sub_background_color) !important;
	}

	.v-sidebar-menu.vsm-default .vsm-item.first-item.open-item > .vsm-link {
		color: #fff;
		background-color: var(--menu_select_background_color) !important;
	}

	.v-sidebar-menu .vsm-mobile-bg {
		color: #fff;
		background-color: var(--menu_select_background_color) !important;
	}

	.v-sidebar-menu .vsm-item.first-item > .vsm-link > .vsm-icon {
		color: #fff;
		background-color: var(--menu_icon_background_color) !important;
	}

	.v-sidebar-menu .collapse-btn {
		color: #fff;
		background-color: var(--menu_icon_background_color) !important;
	}

	.v-sidebar-menu .vsm-dropdown > .vsm-list .vsm-link:hover {
		color: #fff;
		background-color: var(--menu_sub_select_color) !important;
	}

	.v-sidebar-menu.vsm-default .vsm-link:hover {
		color: #fff;
		background-color: var(--menu_select_color) !important;
	}
    .table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
        background-color: WhiteSmoke;
    }
    .long-tooltip .tooltip-inner
    {
        max-width: 600px !important;
        text-align: left !important;
    }
</style>
